/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Class_Floataspect2Inputs */

const de__class_floataspect2 = /** @type {(inputs: _Class_Floataspect2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ist zwischen`)
};

/**

* @param {_Class_Floataspect2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _class_floataspect2 = /** @type {((inputs?: _Class_Floataspect2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Class_Floataspect2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__class_floataspect2(inputs)
});
export { _class_floataspect2 as "_class_FloatAspect" }